/**
 * Created by Bart Decorte
 * Date: 2019-07-16
 * Time: 08:54
 */
import TablesShow from '../TablesShow';
import BlockElementDrag from '../../../utils/BlockElementDrag';

require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/disable-selection');

class TablesShowElementDrag extends BlockElementDrag(TablesShow) {
  constructor(params) {
    super(params);
  }
}

export default TablesShowElementDrag;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/_partials/TablesShowElementDrag.js